<template>
    <RegularModal ref="modal" class="event-cost-breakdown-modal">
        <template v-slot:title>{{ translate("event_cost_breakdown.modal_title") }}</template>
        <template v-slot:body>
            <div class="columns" v-if="initDone">
                <div class="column">
                    <p class="is-size-4 has-text-centered mb-3">
                        {{ translate("event_cost_breakdown.total_cost") }}
                        <span class="has-text-primary">{{ breakdownSummary.sum }}</span>
                    </p>
                    <div>
                        <p class="mb-3">{{ translate("event_cost_breakdown.description") }}</p>

                        <div class="box" v-for="(breakdown, index) in breakdownSummary.breakdowns" :key="index">
                            <div v-if="breakdown.key === 'supportReaction'">
                                <p>
                                    <span class="breakdown-key">{{ translateBreakdownKey(breakdown.key) }}:</span>
                                    <span class="breakdown-description">{{ breakdown.description }}</span>
                                </p>
                                <p>
                                    <small>
                                        {{ translate("common.date") }}:
                                        {{ autoConvertToTimezone(breakdown.date) }}
                                    </small>
                                </p>
                            </div>
                            <p class="breakdown-key" v-else>
                                {{ translateBreakdownKey(breakdown.key) }}
                            </p>

                            <p class="mt-2 is-size-5">
                                {{ breakdown.totalUnits }} × {{ breakdown.singleUnitPrice }} =
                                <span class="has-text-info">{{ breakdown.sum }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-centered" v-else>
                <LoadingSpinner2 class="has-added-margin" />
            </div>
        </template>
        <template v-slot:footer>
            <div class="buttons">
                <a v-if="userRole === 'admin'" class="button is-text" :href="superAdminUrls().manageSupportReactions(eventId)">
                    <span class="icon">
                        <i class="fa fa-wrench" />
                    </span>
                    <span> Manage support reactions </span>
                </a>

                <button class="button" @click="close">{{ translate("common.close") }}</button>
            </div>
        </template>
    </RegularModal>
</template>

<script>
    import RegularModal from "../../Common/RegularModal";
    import apiMixin from "../../Api/apiMixin";
    import translatorMixin from "../../Common/translatorMixin";
    import LoadingSpinner2 from "../../Common/LoadingSpinner2";
    import dateTimeUtilsMixin from "../../Common/dateTimeUtilsMixin";
    import urlsMixin from "../../Urls/urlsMixin";

    export default {
        components: { LoadingSpinner2, RegularModal },
        mixins: [apiMixin, translatorMixin, dateTimeUtilsMixin, urlsMixin],
        props: ["eventId", "userRole"],
        data() {
            return {
                initDone: false,
                breakdownSummary: {},
            };
        },
        methods: {
            open() {
                this.initDone = false;
                this.$refs.modal.open();

                return this.billingApi()
                    .getEventCostBreakdown(this.eventId)
                    .then(breakdownSummary => (this.breakdownSummary = breakdownSummary))
                    .finally(() => {
                        this.initDone = true;
                    });
            },
            close() {
                this.$refs.modal.close();
            },
            translateBreakdownKey(key) {
                return this.translate("event_cost_breakdown.key." + key);
            },
        },
    };
</script>
